import { useEffect } from "react";
import { SERVER_URL } from "../../../config/config";
import { parseBulletBuyInfo } from "../../../helper/game";

const useBulletFactorySSE = (
  account: string,
  onSuccess: (cashAmount: number, bulletAmount: number) => void,
  onFailed: (bulletAmount: number) => void,
  _: () => void
) => {
  useEffect(() => {
    const eventSource = new EventSource(`${SERVER_URL}/event/bulletfactory`);
    eventSource.onmessage = (e) => {
      if (e.data.includes("welcome")) {
        // Handle welcome message if needed
      } else if (e.data.includes("eventName")) {
        const event = JSON.parse(e.data);

        if (event.eventName === "BulletBuy") {
          const bulletInfo = parseBulletBuyInfo(event.data);

          if (bulletInfo.buyer.toLowerCase() === account.toLowerCase()) {
            if (bulletInfo.isSuccess) {
              onSuccess(bulletInfo.cashAmount, bulletInfo.bulletAmount);
              return;
            }

            if (!bulletInfo.isSuccess) {
              onFailed(bulletInfo.bulletAmount);
              return;
            }
          }
        }
      }
    };
    return () => {
      eventSource.close();
    };
  }, [account, onFailed, onSuccess]);
};

export default useBulletFactorySSE;
